import type { ReactNode } from 'react'
import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { Icon, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon, TickIcon } from '@fourthwall/icons'

import * as S from './SubscriptionPerk.styled'
import type { SubscriptionPerkIconAppearance } from './SubscriptionPerk.types'

export type PerkProps = {
  icon?: IconComponent
  iconSize?: number
  iconAppearance?: SubscriptionPerkIconAppearance
  tooltip?: string
  children: ReactNode
}

export const SubscriptionPerk = ({
  icon = TickIcon,
  iconSize = 20,
  iconAppearance = 'normal',
  tooltip,
  children,
}: PerkProps) => {
  return (
    <S.Container>
      <S.IconContainer $appearance={iconAppearance}>
        <Icon component={icon} height={iconSize} />
      </S.IconContainer>
      <S.ContentContainer>{children}</S.ContentContainer>
      {tooltip && (
        <Tooltip
          placement="top"
          reference={
            <S.TooltipContainer>
              <Icon component={QuestionMarkIcon} height={16} />
            </S.TooltipContainer>
          }
        >
          {tooltip}
        </Tooltip>
      )}
    </S.Container>
  )
}
